(function () {
  // 防止脚本重复加载
  if (window.__emailSignupScriptLoaded) return;
  window.__emailSignupScriptLoaded = true;

  /**
   * Email Signup Block Component
   * 处理 input padding 自适应按钮宽度
   */
  const EmailSignupBlock = class extends HTMLElement {
    constructor() {
      super();
      this.lastButtonWidth = 0;
    }

    connectedCallback() {
      this.button = this.querySelector('.email-signup__button--integrated');
      this.input = this.querySelector('.email-signup__input');
      this.inputGroup = this.querySelector('.email-signup__input-group');

      if (
        this.button &&
        this.input &&
        this.inputGroup &&
        this.button.classList.contains('email-signup__button--text')
      ) {
        this.adjustInputPadding();

        this.observer = new ResizeObserver(() => {
          this.adjustInputPadding();
        });
        this.observer.observe(this.button);

        if ('fonts' in document) {
          document.fonts.ready.then(() => this.adjustInputPadding());
        }
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    adjustInputPadding() {
      if (!this.button || !this.inputGroup) return;

      const width = this.button.offsetWidth;

      if (width !== this.lastButtonWidth) {
        this.lastButtonWidth = width;
        this.inputGroup.style.setProperty('--button-actual-width', `${width}px`);
      }
    }
  };

  // 注册组件
  if (!customElements.get('email-signup-block')) {
    try {
      customElements.define('email-signup-block', EmailSignupBlock);
    } catch (e) {
      console.warn('email-signup-block define failed:', e);
    }
  }
})();
  
/**
 * ------------------------------------------------------------
 *  ✨ 成功提交订阅后自动跳转 (适用于 Shopify newsletter)
 * ------------------------------------------------------------
 * Shopify 表单提交后会刷新页面并加上：
 *   ?customer_posted=true
 * 我们在页面加载时检测该参数并执行跳转
 */
document.addEventListener("DOMContentLoaded", () => {
  const url = new URL(window.location.href);

  // ---- 清除 customer_posted 参数（防止回退时再次触发） ----
  if (url.searchParams.has("customer_posted")) {
    // ---- 如果当前页面是刚提交成功的页面，则跳转 ----
    if (new URL(window.location.href).searchParams.get("customer_posted") === "true") {
      const button = document.querySelector('button[data-redirect-url]');
      if (!button) return;

      const redirectUrl = button.dataset.redirectUrl;
      if (redirectUrl) {
        window.location.href = redirectUrl;
      }
    }
    url.searchParams.delete("customer_posted");
    history.replaceState({}, "", url.pathname + url.search);
  }
});